var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19 19) scale(0.8125)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M26.7,6.7c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0l-5.2,5.2l1.8,1c0,0,0,0,0.1,0L26.7,6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M14.9,23.8l-0.9-0.5l-2,2c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0l3-3C16,23.8,16,23.8,16,23.8H14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M22.7,17.4v-2.8l2.6-2.6c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4L22.7,17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M11.5,21.9l-1.8-1l-4.4,4.4c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0L11.5,21.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M9.2,14.7v2.8L6.7,20c-0.4,0.4-1,0.4-1.4,0c-0.4-0.4-0.4-1,0-1.4L9.2,14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M15.7,8.2l3-3c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4l-2.4,2.4l-1.5-0.8C16,8.2,15.8,8.2,15.7,8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M13.4,6.7c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0L5.3,12c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0L13.4,6.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M7.2,6.7c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0L5.3,5.8c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0L7.2,6.7z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M26.7,20c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0l-6.7,6.7c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0L26.7,20 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M26.7,26.2c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0l-0.5,0.5c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0 L26.7,26.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M11.4,13.3c-0.3-0.2-0.3-0.6,0-0.8l4.3-2.5c0.1-0.1,0.3-0.1,0.5,0l4.4,2.5c0.3,0.2,0.3,0.6,0,0.8l-4.4,2.5 c-0.1,0.1-0.3,0.1-0.5,0L11.4,13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M10.9,19.7c-0.1-0.1-0.2-0.2-0.2-0.4v-5c0-0.4,0.4-0.6,0.7-0.4l4,2.3c0.1,0.1,0.2,0.2,0.2,0.4v5 c0,0.4-0.4,0.6-0.7,0.4L10.9,19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M20.6,13.9c0.3-0.2,0.7,0.1,0.7,0.4v5c0,0.2-0.1,0.3-0.2,0.4L16.9,22c-0.3,0.2-0.7-0.1-0.7-0.4v-5 c0-0.2,0.1-0.3,0.2-0.4L20.6,13.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/Background.ad2a0632e6fdb0032d600e8d07f35063.svg";
export { ForwardRef as ReactComponent };